import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { TripPage } from './pages/TripPage';
import { TRIP_TABS } from './trips.paths';

export const TRIP_ROUTES: RouteObject[] = recordTabRoutes('trips/:id', TRIP_TABS, (tab) => <TripPage tab={tab} />);
